module.exports = __webpack_public_path__ + "static/img/3562_phase_function_Paper_PointsHejduk_Prediction.96e22ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3562_phase_function_Paper_PointsHejduk_Prediction.png
// module id = TTSO
// module chunks = 0